import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

const ProgressBar = ({ progress = 0 }) => {
  const style = { width: `${progress}%` };

  return (
    <div className="ProgressBar">
      <div className="ProgressBar__indicator" style={style} />

      <style jsx>
        {`
          .ProgressBar {
            display: block;
            position: relative;
            background-color: ${Theme.get('colors-grey')};
            height: 8px;
          }

          .ProgressBar__indicator {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            background-color: ${Theme.get('colors-blue')};
            transition: width ease-in-out 750ms;
            transform: translate3d(0, 0, 0);
          }
        `}
      </style>
    </div>
  );
};

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default ProgressBar;
